export default __webpack_public_path__ + "static/media/NH007.4a6f79c7.jpg";